export default {
  type: 'Topology',
  bbox: [
    15.996611246900432,
    46.83070724710216,
    17.160775946663158,
    48.11870332977119,
  ],
  transform: {
    scale: [0.000011641763415261407, 0.000012880089627586598],
    translate: [15.996611246900432, 46.83070724710216],
  },
  objects: {
    gemeinden: {
      type: 'GeometryCollection',
      geometries: [
        {
          type: 'Polygon',
          arcs: [[0, 1, 2]],
          properties: {
            name: 'Neuhaus am Klausenbach',
            iso: '10507',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[3, 4, 5]],
          properties: {
            name: 'Neustift an der Lafnitz',
            iso: '10929',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[6, 7, 8, -1]],
          properties: { name: 'Muehlgraben', iso: '10512', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[9, 10, -4, 11]],
          properties: { name: 'Grafenschachen', iso: '10904', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-5, -11, 12, 13, 14, 15]],
          properties: {
            name: 'Loipersdorf-Kitzladen',
            iso: '10910',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-9, 16, 17, -2]],
          properties: { name: 'Minihof-Liebau', iso: '10505', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[18, 19, 20, 21, -17, -8]],
          properties: {
            name: 'Sankt Martin an der Raab',
            iso: '10509',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-15, 22, 23, 24, 25, 26]],
          properties: { name: 'Markt Allhau', iso: '10912', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[27, 28, 29, 30, -13, -10]],
          properties: { name: 'Pinkafeld', iso: '10918', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-26, 31, 32, 33, 34, 35]],
          properties: { name: 'Wolfau', iso: '10928', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-35, 36, 37, 38]],
          properties: { name: 'Woerterberg', iso: '10419', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[39, 40, 41, 42, 43]],
          properties: {
            name: 'Deutsch Kaltenbrunn',
            iso: '10501',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-38, 44, 45, 46, 47, 48]],
          properties: { name: 'Hackerberg', iso: '10418', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[49, 50, -20, 51]],
          properties: { name: 'Jennersdorf', iso: '10504', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-43, 52, 53, 54]],
          properties: { name: 'Rudersdorf', iso: '10508', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-34, 55, 56, -45, -37]],
          properties: { name: 'Stinatz', iso: '10415', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-48, 57, 58, -40, 59]],
          properties: {
            name: 'Burgauberg-Neudauberg',
            iso: '10402',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-31, 60, 61, -23, -14]],
          properties: { name: 'Riedlingsdorf', iso: '10920', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[62, 63, -29]],
          properties: { name: 'Wiesfleck', iso: '10927', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-25, 64, 65, 66, -32]],
          properties: { name: 'Kemeten', iso: '10907', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-33, -67, 67, 68, 69, 70, -56]],
          properties: { name: 'Litzelsdorf', iso: '10909', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-57, -71, 71, 72, -46]],
          properties: {
            name: 'Ollersdorf im Burgenland',
            iso: '10412',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-73, 73, 74, 75, 76, -58, -47]],
          properties: { name: 'Stegersbach', iso: '10414', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-42, 77, 78, 79, 80, 81, 82, -53]],
          properties: { name: 'Kukmirn', iso: '10408', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-62, 83, 84, 85, 86, -65, -24]],
          properties: { name: 'Oberwart', iso: '10917', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-59, -77, 87, 88, -78, -41]],
          properties: {
            name: 'Rohr im Burgenland',
            iso: '10425',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-54, -83, 89, 90, -50, 91]],
          properties: { name: 'Koenigsdorf', iso: '10511', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-64, 92, 93, 94, 95, -84, -61, -30]],
          properties: { name: 'Oberschuetzen', iso: '10916', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-76, 96, 97, -88]],
          properties: { name: 'Bocksdorf', iso: '10401', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[98, -79, -89, -98]],
          properties: { name: 'Heugraben', iso: '10424', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-91, 99, 100, 101, 102, -21, -51]],
          properties: { name: 'Weichselbaum', iso: '10510', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-70, 103, 104, 105, 106, -74, -72]],
          properties: { name: 'Olbendorf', iso: '10411', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-66, -87, 107, 108, 109, -68]],
          properties: { name: 'Unterwart', iso: '10925', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-110, 110, 111, -104, -69]],
          properties: {
            name: 'Oberdorf im Burgenland',
            iso: '10915',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-82, 112, 113, 114, -100, -90]],
          properties: { name: 'Eltendorf', iso: '10502', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-97, -75, -107, 115, 116, -99]],
          properties: { name: 'Rauchwart', iso: '10427', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[117, 118, -102]],
          properties: { name: 'Mogersdorf', iso: '10506', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[119, 120, 121, -95]],
          properties: { name: 'Mariasdorf', iso: '10911', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[122, 123, 124, 125, -120, -94]],
          properties: { name: 'Bernstein', iso: '10902', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-115, 126, 127, 128, 129, -118, -101]],
          properties: {
            name: 'Heiligenkreuz im Lafnitztal',
            iso: '10503',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-122, 130, -85, -96]],
          properties: {
            name: 'Bad Tatzmannsdorf',
            iso: '10901',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-117, 131, 132, 133, 134, -80]],
          properties: {
            name: 'St. Michael im Burgenland',
            iso: '10413',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-135, 135, 136, 137, -113, -81]],
          properties: { name: 'Gerersdorf-Sulz', iso: '10404', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-109, 138, 139, 140, 141, -111]],
          properties: {
            name: 'Rotenturm an der Pinka',
            iso: '10921',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[142, 143, -132, -116, -106]],
          properties: {
            name: 'Neuberg im Burgenland',
            iso: '10409',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-112, -142, 144, 145, 146, 147, 148, -143, -105]],
          properties: { name: 'Mischendorf', iso: '10914', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-138, 149, -127, -114]],
          properties: {
            name: 'Neustift bei Guessing',
            iso: '10410',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-121, -126, 150, 151, 152, -139, -108, -86, -131]],
          properties: { name: 'Stadtschlaining', iso: '10923', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[153, -145, -141]],
          properties: { name: 'Jabing', iso: '10930', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-137, 154, 155, 156, 157, 158, 159, -128, -150]],
          properties: { name: 'Guessing', iso: '10405', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-134, 160, 161, 162, 163, 164, -155, -136]],
          properties: { name: 'Tobaj', iso: '10417', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[165, 166, 167, 168]],
          properties: { name: 'Neudoerfl', iso: '10607', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-149, 169, -161, -133, -144]],
          properties: { name: 'Guettenbach', iso: '10406', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[170, 171, 172, 173, 174, -124]],
          properties: { name: 'Pilgersdorf', iso: '10817', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-175, 175, 176, -151, -125]],
          properties: {
            name: 'Unterkohlstaetten',
            iso: '10924',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-140, -153, 177, 178, 179, 180, -146, -154]],
          properties: { name: 'Grosspetersdorf', iso: '10905', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-160, 181, 182, 183, 184, 185, -129]],
          properties: { name: 'Inzenhof', iso: '10421', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[186, 187, 188, 189, 190, 191]],
          properties: { name: 'Wiesen', iso: '10615', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[192, -182, -159]],
          properties: { name: 'Kleinmuerbisch', iso: '10422', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-191, 193, 194]],
          properties: { name: 'Forchtenstein', iso: '10602', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-177, 195, 196, 197, -178, -152]],
          properties: {
            name: 'Weiden bei Rechnitz',
            iso: '10926',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-185, 198]],
          properties: { name: 'Tschanigraben', iso: '10423', iso_alt: null },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [[199, 200, 201, 202, 203, -189, 204, -166]],
            [[205, -187, 206, -168]],
          ],
          properties: { name: 'Poettsching', iso: '10609', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[207, 208, 209, 210, 211, 212, 213, 214, 215]],
          properties: { name: 'Markt St. Martin', iso: '10812', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-194, -190, -204, 216, 217, 218, 219, 220]],
          properties: { name: 'Mattersburg', iso: '10606', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-205, -188, -206, -167]],
          properties: { name: 'Bad Sauerbrunn', iso: '10611', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[221, -213, 222, 223, 224, 214]],
          properties: { name: 'Weingraben', iso: '10827', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-148, 225, 226, -162, -170]],
          properties: { name: 'Kohfidisch', iso: '10908', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-224, 227, 228, 229, 230, 231, 232, -172, 233]],
          properties: { name: 'Drassmarkt', iso: '10802', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-193, -158, 234, 235, -183]],
          properties: { name: 'Grossmuerbisch', iso: '10420', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[236, 237, -208, 238]],
          properties: { name: 'Kobersdorf', iso: '10807', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-233, 239, 240, -173]],
          properties: {
            name: 'Unterrabnitz-Schwendgraben',
            iso: '10826',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-198, 241, 242, 243, 244, 245, -179]],
          properties: { name: 'Schachendorf', iso: '10922', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-212, 246, -228, -223]],
          properties: { name: 'Kaisersdorf', iso: '10806', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[247, 248, 249]],
          properties: {
            name: 'Neufeld an der Leitha',
            iso: '10309',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-174, -241, 250, 251, 252, 253, 254, 255, 256, -196, -176]],
          properties: { name: 'Lockenhaus', iso: '10809', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-220, 257, 258, 259, 260, -237, 261]],
          properties: { name: 'Sieggraben', iso: '10613', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-181, 262, 263, -226, -147]],
          properties: { name: 'Badersdorf', iso: '10931', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-246, 264, 265, 266, -263, -180]],
          properties: { name: 'Hannersdorf', iso: '10906', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[267, 268, 269, 270, 271, 272, 273, 274, -201]],
          properties: { name: 'Zillingtal', iso: '10322', iso_alt: null },
        },
        {
          type: 'MultiPolygon',
          arcs: [[[275, 276, 277, -258, -219]], [[278, 279, 280]]],
          properties: { name: 'Marz', iso: '10605', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-257, 281, -242, -197]],
          properties: { name: 'Markt Neuhodis', iso: '10913', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[282, 283, -217, -203]],
          properties: { name: 'Sigless', iso: '10614', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-157, 284, 285, 286, -235]],
          properties: { name: 'Heiligenbrunn', iso: '10407', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-249, 287, 288, -269, 289]],
          properties: { name: 'Steinbrunn', iso: '10316', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-261, 290, 291, -209, -238]],
          properties: { name: 'Weppersdorf', iso: '10823', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-156, -165, 292, 293, -285]],
          properties: { name: 'Strem', iso: '10416', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[294, 295, 296, 297, 298, 299, 300, -288, -248]],
          properties: { name: 'Hornstein', iso: '10304', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-256, 301, -243, -282]],
          properties: { name: 'Rechnitz', iso: '10919', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-232, 302, -251, -240]],
          properties: { name: 'Piringsdorf', iso: '10818', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-267, 303, 304, 305, -163, -227, -264]],
          properties: {
            name: 'Deutsch Schuetzen-Eisenberg',
            iso: '10903',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-306, 306, 307, 308, -293, -164]],
          properties: { name: 'Eberau', iso: '10403', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[309, -265, -245]],
          properties: { name: 'Schandorf', iso: '10932', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-202, -275, 310, 311, -283]],
          properties: { name: 'Krensdorf', iso: '10619', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[312, 313, 314, 315, 316, -252, -303, -231]],
          properties: { name: 'Steinberg-Doerfl', iso: '10821', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-312, 317, -276, -218, -284]],
          properties: { name: 'Poettelsdorf', iso: '10608', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-260, 318, 319, 320, 321, 322, -291]],
          properties: { name: 'Lackenbach', iso: '10808', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[323, -281, 324, 325, 326, -319, -259, -278]],
          properties: {
            name: 'Rohrbach bei Mattersburg',
            iso: '10610',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-247, -211, 327, 328, -229]],
          properties: { name: 'Neutal', iso: '10814', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[329, -296, 330]],
          properties: {
            name: 'Wimpassing an der Leitha',
            iso: '10318',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-311, -274, 331, 332, 333, -324, -277, -318]],
          properties: {
            name: 'Zemendorf-Stoettera',
            iso: '10618',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-301, 334, -270, -289]],
          properties: { name: 'Muellendorf', iso: '10308', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-309, 335, -286, -294]],
          properties: { name: 'Moschendorf', iso: '10428', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-273, 336, 337, -332]],
          properties: { name: 'Hirm', iso: '10603', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[338, -316, 339, 340, -254]],
          properties: {
            name: 'Mannersdorf an der Rabnitz',
            iso: '10811',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[341, 342, 343, 344, -322]],
          properties: { name: 'Lackendorf', iso: '10824', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[345, -307, -305]],
          properties: { name: 'Bildein', iso: '10426', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-329, 346, 347, 348, 349, -313, -230]],
          properties: { name: 'Stoob', iso: '10822', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[350, 351, -326]],
          properties: {
            name: 'Loipersbach im Burgenland',
            iso: '10604',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-272, 352, 353, 354, 355, 356, -337]],
          properties: { name: 'Wulkaprodersdorf', iso: '10319', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-334, 357, 358, 359, 360, -279]],
          properties: { name: 'Drassburg', iso: '10601', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-335, -300, 361, -353, -271]],
          properties: { name: 'Grosshoeflein', iso: '10303', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[362, 363, -342, -321]],
          properties: { name: 'Ritzing', iso: '10820', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[364, 365, 366, 367, -297, -330]],
          properties: {
            name: 'Leithaprodersdorf',
            iso: '10306',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-280, -361, 368, 369, -351, -325]],
          properties: { name: 'Schattendorf', iso: '10612', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-338, -357, 370, -358, -333]],
          properties: { name: 'Antau', iso: '10616', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-253, -317, -339]],
          properties: { name: 'Oberloisdorf', iso: '10828', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-292, -323, -345, 371, -347, -328, -210]],
          properties: { name: 'Unterfrauenhaid', iso: '10825', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-360, 372, 373, -369]],
          properties: { name: 'Baumgarten', iso: '10617', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-350, 374, 375, -314]],
          properties: { name: 'Oberpullendorf', iso: '10816', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-299, 376, 377, 378, 379, -354, -362]],
          properties: { name: 'Eisenstadt', iso: '10101', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[380, 381, 382, 383, -343, -364]],
          properties: { name: 'Neckenmarkt', iso: '10813', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-371, -356, 384, 385, 386, -373, -359]],
          properties: { name: 'Zagersdorf', iso: '10323', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[387, -367]],
          properties: { name: 'Loretto', iso: '10320', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-344, -384, 388, 389, -348, -372]],
          properties: { name: 'Raiding', iso: '10819', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-390, 390, 391, 392, 393, -375, -349]],
          properties: { name: 'Grosswarasdorf', iso: '10804', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-368, -388, -366, 394, 395, -377, -298]],
          properties: { name: 'Stotzing', iso: '10321', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-355, -380, 396, 397, 398, 399, -385]],
          properties: { name: 'Siegendorf', iso: '10315', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-376, -394, 400, 401, 402, -340, -315]],
          properties: {
            name: 'Frankenau-Unterpullendorf',
            iso: '10803',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-383, 403, -391, -389]],
          properties: { name: 'Horitschon', iso: '10805', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-400, 404, -386]],
          properties: { name: 'Klingenbach', iso: '10305', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[405, 406, -397, -379]],
          properties: {
            name: 'Trausdorf an der Wulka',
            iso: '10317',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-396, 407, 408, 409, 410, 411, -406, -378]],
          properties: { name: 'Oslip', iso: '10311', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-407, -412, 412, 413, 414, -398]],
          properties: {
            name: 'Sankt Margarethen im Burgenland',
            iso: '10313',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[415, 416, -409, 417]],
          properties: {
            name: 'Schuetzen am Gebirge',
            iso: '10314',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[418, 419, 420, -401, -393]],
          properties: { name: 'Nikitsch', iso: '10815', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[421, -419, -392, -404, -382]],
          properties: { name: 'Deutschkreuz', iso: '10801', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-421, 422, -402]],
          properties: { name: 'Lutzmannsburg', iso: '10810', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[423, 424, 425, -416, 426]],
          properties: { name: 'Donnerskirchen', iso: '10302', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[427, 428, -424, 429]],
          properties: {
            name: 'Purbach am Neusiedler See',
            iso: '10312',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-414, 430, 431, 432]],
          properties: { name: 'Moerbisch am See', iso: '10307', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-411, 433, 434, -431, -413]],
          properties: { name: 'Rust', iso: '10201', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-417, -426, 435, 436, 437, -434, -410]],
          properties: {
            name: 'Oggau am Neusiedler See',
            iso: '10310',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[438, 439, 440, 441, -428]],
          properties: {
            name: 'Breitenbrunn am Neusiedler See',
            iso: '10301',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[442, 443, 444, -440, 445]],
          properties: { name: 'Bruckneudorf', iso: '10703', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[446, 447, -441, -445]],
          properties: { name: 'Winden am See', iso: '10723', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-435, -438, 448, 449, 450, -432]],
          properties: { name: 'Illmitz', iso: '10709', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-437, 451, 452, 453, 454, 455, 456, -449]],
          properties: {
            name: 'Podersdorf am See',
            iso: '10718',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-450, -457, 457, 458, 459, 460]],
          properties: { name: 'Apetlon', iso: '10702', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-444, 461, 462, -447]],
          properties: { name: 'Jois', iso: '10710', iso_alt: null },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [[-436, -425, -429, -442, -448, -463, 463, 464, -452]],
            [[465, 466, -454]],
          ],
          properties: { name: 'Neusiedl am See', iso: '10713', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-443, 467, 468, 469, 470, 471, -464, -462]],
          properties: { name: 'Parndorf', iso: '10717', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-465, 472, 473, -466, -453]],
          properties: { name: 'Weiden am See', iso: '10722', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-467, -474, 474, 475, 476, -455]],
          properties: { name: 'Gols', iso: '10707', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[477, 478, 479, -460]],
          properties: { name: 'Pamhagen', iso: '10716', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-477, 480, 481, 482, -458, -456]],
          properties: { name: 'Frauenkirchen', iso: '10705', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[483, 484, -470]],
          properties: {
            name: 'Neudorf bei Parndorf',
            iso: '10725',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-483, 485, 486, 487, 488, -478, -459]],
          properties: {
            name: 'St.Andrae am Zicksee',
            iso: '10719',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[489, 490, 491, -481, -476]],
          properties: { name: 'Moenchhof', iso: '10712', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[492, 493, -484, -469]],
          properties: { name: 'Potzneusiedl', iso: '10726', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-472, 494, 495, 496, 497, -490, -475, -473]],
          properties: { name: 'Zurndorf', iso: '10724', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-471, -485, -494, 498, 499, -495]],
          properties: { name: 'Gattendorf', iso: '10706', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-489, 500, 501, -479]],
          properties: {
            name: 'Wallern im Burgenland',
            iso: '10721',
            iso_alt: null,
          },
        },
        {
          type: 'Polygon',
          arcs: [[-492, 502, 503, 504, -486, -482]],
          properties: { name: 'Halbturn', iso: '10708', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[505, 506, -501, -488]],
          properties: { name: 'Tadten', iso: '10720', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[507, 508]],
          properties: { name: 'Edelstal', iso: '10727', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-505, 509, -506, -487]],
          properties: { name: 'Andau', iso: '10701', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[510, 511, 512, 513, -496, -500]],
          properties: { name: 'Pama', iso: '10715', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-498, 514, 515, -503, -491]],
          properties: { name: 'Nickelsdorf', iso: '10714', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-508, 516, -512, 517]],
          properties: { name: 'Kittsee', iso: '10711', iso_alt: null },
        },
        {
          type: 'Polygon',
          arcs: [[-514, 518, -515, -497]],
          properties: {
            name: 'Deutsch Jahrndorf',
            iso: '10704',
            iso_alt: null,
          },
        },
      ],
    },
    bezirke: {
      type: 'GeometryCollection',
      geometries: [
        {
          type: 'MultiPolygon',
          arcs: [[[-299, 376, 377, 378, 379, -354, -362]]],
          properties: { iso: '101', name: 'Eisenstadt' },
        },
        {
          type: 'MultiPolygon',
          arcs: [[[-411, 433, 434, -431, -413]]],
          properties: { iso: '102', name: 'Rust' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                330,
                364,
                394,
                407,
                417,
                426,
                429,
                438,
                439,
                440,
                441,
                428,
                424,
                435,
                436,
                437,
                -434,
                410,
                412,
                430,
                431,
                432,
                414,
                398,
                404,
                386,
                -373,
                -359,
                -371,
                356,
                -337,
                272,
                273,
                274,
                -201,
                267,
                289,
                249,
                294,
              ],
              [361, 353, -380, -379, -378, -377, 298],
            ],
          ],
          properties: { iso: '103', name: 'Eisenstadt-Umgebung' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                -71,
                -70,
                103,
                104,
                142,
                -149,
                169,
                161,
                162,
                -306,
                -305,
                345,
                307,
                335,
                286,
                235,
                183,
                198,
                185,
                -129,
                -128,
                -127,
                -114,
                -113,
                81,
                82,
                -53,
                -42,
                -41,
                -40,
                59,
                48,
                38,
                -35,
                -34,
                55,
              ],
            ],
          ],
          properties: { iso: '104', name: 'Güssing' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                18,
                51,
                91,
                54,
                43,
                39,
                40,
                41,
                52,
                -83,
                -82,
                112,
                113,
                126,
                127,
                128,
                129,
                118,
                102,
                21,
                17,
                2,
                6,
              ],
            ],
          ],
          properties: { iso: '105', name: 'Jennersdorf' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                -275,
                -274,
                -273,
                336,
                -357,
                370,
                358,
                372,
                373,
                369,
                351,
                326,
                -319,
                259,
                260,
                -237,
                261,
                220,
                194,
                191,
                206,
                168,
                199,
                200,
              ],
            ],
          ],
          properties: { iso: '106', name: 'Mattersburg' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                492,
                498,
                510,
                517,
                508,
                516,
                512,
                518,
                515,
                503,
                509,
                506,
                501,
                479,
                460,
                450,
                -432,
                -435,
                -438,
                -437,
                -436,
                -425,
                -429,
                -442,
                -441,
                -440,
                445,
                467,
              ],
            ],
          ],
          properties: { iso: '107', name: 'Neusiedl am See' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                215,
                238,
                236,
                -261,
                -260,
                318,
                319,
                362,
                380,
                421,
                419,
                422,
                402,
                340,
                254,
                255,
                256,
                -196,
                -176,
                174,
                -124,
                170,
                233,
                224,
              ],
              [213, -214, 519],
              [221, -222, 520],
            ],
          ],
          properties: { iso: '108', name: 'Oberpullendorf' },
        },
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                27,
                62,
                92,
                122,
                123,
                -175,
                175,
                195,
                -257,
                -256,
                301,
                243,
                309,
                265,
                303,
                304,
                305,
                -163,
                -162,
                -170,
                148,
                -143,
                -105,
                -104,
                69,
                70,
                -56,
                33,
                34,
                35,
                26,
                15,
                5,
                11,
              ],
            ],
          ],
          properties: { iso: '109', name: 'Oberwart' },
        },
      ],
    },
    bundeslaender: {
      type: 'GeometryCollection',
      geometries: [
        {
          type: 'MultiPolygon',
          arcs: [
            [
              [
                215,
                238,
                261,
                220,
                194,
                191,
                206,
                168,
                199,
                267,
                289,
                249,
                294,
                330,
                364,
                394,
                407,
                417,
                426,
                429,
                438,
                445,
                467,
                492,
                498,
                510,
                517,
                508,
                516,
                512,
                518,
                515,
                503,
                509,
                506,
                501,
                479,
                460,
                450,
                432,
                414,
                398,
                404,
                386,
                373,
                369,
                351,
                326,
                319,
                362,
                380,
                421,
                419,
                422,
                402,
                340,
                254,
                301,
                243,
                309,
                265,
                303,
                345,
                307,
                335,
                286,
                235,
                183,
                198,
                185,
                129,
                118,
                102,
                21,
                17,
                2,
                6,
                18,
                51,
                91,
                54,
                43,
                59,
                48,
                38,
                35,
                26,
                15,
                5,
                11,
                27,
                62,
                92,
                122,
                170,
                233,
                224,
              ],
              [213, -214, 519],
              [221, -222, 520],
            ],
          ],
          properties: { iso: '1', name: 'Burgenland' },
        },
      ],
    },
  },
  arcs: [
    [[2312, 4460], [597, -504], [1390, -124]],
    [
      [4299, 3832],
      [598, -458],
      [246, 47],
      [117, -683],
      [-623, -651],
      [610, -55],
      [689, -543],
    ],
    [
      [5936, 1489],
      [26, -294],
      [-663, -574],
      [-636, -86],
      [-844, 186],
      [-104, -302],
      [-520, -47],
      [-376, 373],
      [-1325, -326],
      [-520, -419],
      [-558, 62],
      [-416, 279],
      [312, 132],
      [506, 660],
      [-298, 124],
      [-117, 101],
      [623, 799],
      [91, 1450],
      [364, 574],
      [831, 279],
    ],
    [[3221, 42044], [792, 24], [351, -450], [-26, -613], [650, -861]],
    [[4988, 40144], [-1195, 714], [-559, -117]],
    [[3234, 40741], [-286, 8], [-571, 597], [-714, 388], [1558, 310]],
    [[2312, 4460], [1013, 365], [221, 915], [714, 404], [676, 39]],
    [[4936, 6183], [-39, -644], [182, -497], [350, 16]],
    [[5429, 5058], [260, -667], [-610, -24], [-780, -535]],
    [
      [5377, 42944],
      [455, -442],
      [987, 109],
      [688, -117],
      [260, -667],
      [-610, -217],
      [571, -822],
    ],
    [[7728, 40788], [-2740, -644]],
    [[3221, 42044], [-351, 551], [975, 241], [1532, 108]],
    [[7728, 40788], [637, -163], [181, -341], [1040, -575]],
    [[9586, 39709], [272, -186]],
    [
      [9858, 39523],
      [-532, -232],
      [-896, -163],
      [155, -357],
      [-428, -574],
      [-611, -318],
      [-1987, -435],
      [-156, 132],
    ],
    [
      [5403, 37576],
      [-766, 396],
      [182, 271],
      [-429, 287],
      [286, 388],
      [-689, 551],
      [-51, 372],
      [-468, -69],
      [26, 372],
      [-390, 380],
      [130, 217],
    ],
    [
      [5429, 5058],
      [507, 108],
      [428, 435],
      [884, -140],
      [389, 334],
      [1403, -264],
      [649, -535],
      [-467, -62],
      [-52, -675],
      [-1299, -1397],
      [364, -232],
    ],
    [[8235, 2630], [-1156, -931], [-650, 39], [-493, -249]],
    [[4936, 6183], [701, 403], [65, 721], [507, 753], [2221, -16]],
    [
      [8430, 8044],
      [454, -341],
      [1156, -256],
      [1221, -109],
      [416, 412],
      [441, -264],
      [572, 0],
      [351, 310],
      [1558, -155],
      [1338, 318],
    ],
    [[15937, 7959], [338, 341], [1013, 163]],
    [
      [17288, 8463],
      [-208, -70],
      [-649, -1225],
      [-325, -334],
      [-520, -985],
      [-636, -209],
      [-676, 124],
      [-363, -629],
      [-896, -333],
      [-351, -559],
      [-533, -15],
      [-428, -745],
      [-1936, -527],
      [-1078, -621],
      [-454, 295],
    ],
    [[9858, 39523], [273, -512], [844, -884], [1065, -838]],
    [[12040, 37289], [-181, -543], [52, -1163], [246, -396], [897, -590]],
    [[13054, 34597], [-1351, -643], [-416, 77]],
    [
      [11287, 34031],
      [-584, 78],
      [-1507, 496],
      [-987, -85],
      [104, -372],
      [-507, 7],
      [-39, 256],
      [-1052, 70],
    ],
    [
      [6715, 34481],
      [-792, 791],
      [39, 365],
      [-520, 923],
      [221, 241],
      [-351, 418],
      [91, 357],
    ],
    [
      [5377, 42944],
      [572, 272],
      [-182, 302],
      [688, 1001],
      [1065, 388],
      [442, -652],
      [-610, -264],
      [961, -550],
      [1195, 504],
      [-637, 814],
      [117, 582],
      [1273, -62],
    ],
    [
      [10261, 45279],
      [13, -364],
      [1039, -567],
      [-623, -457],
      [454, -621],
      [520, -349],
      [532, -869],
      [806, -147],
      [168, -334],
      [767, -457],
    ],
    [[13937, 41114], [-429, 100], [-299, -310]],
    [[13209, 40904], [-805, 124], [-623, -295], [-1962, -628], [-233, -396]],
    [
      [11287, 34031],
      [-1000, -582],
      [195, -333],
      [675, -303],
      [-39, -201],
      [559, -481],
      [-650, -109],
      [676, -1133],
    ],
    [[11703, 30889], [-663, 8]],
    [[11040, 30897], [-818, 186], [-740, 0], [-767, 218]],
    [[8715, 31301], [-350, 100], [-741, -287]],
    [
      [7624, 31114],
      [-52, 39],
      [182, 799],
      [-506, 753],
      [-130, 566],
      [195, 217],
      [-468, 745],
      [-130, 248],
    ],
    [[8715, 31301], [377, -404], [-117, -597], [559, -830], [26, -691]],
    [[9560, 28779], [-1039, -325]],
    [
      [8521, 28454],
      [-377, 101],
      [104, 411],
      [-546, 488],
      [-104, 1117],
      [-363, 194],
      [389, 349],
    ],
    [[10144, 23466], [1507, -16], [493, -147]],
    [[12144, 23303], [104, -1226], [286, -341], [1143, -597]],
    [[13677, 21139], [-1351, -1226], [-428, -543], [-533, -334]],
    [[11365, 19036], [-364, -372], [-1961, -512], [-312, -256]],
    [
      [8728, 17896],
      [-831, 846],
      [143, 791],
      [-312, 434],
      [650, 458],
      [-299, 349],
      [351, 1078],
      [896, 155],
      [337, 986],
      [481, 473],
    ],
    [[9560, 28779], [740, -527], [1117, -481]],
    [[11417, 27771], [-234, -256], [143, -442]],
    [[11326, 27073], [-26, -78]],
    [[11300, 26995], [-1416, 419], [-818, -46]],
    [[9066, 27368], [117, 232], [-559, 412], [-103, 442]],
    [[13560, 12427], [1338, -225], [234, 210], [1182, -474]],
    [
      [16314, 11938],
      [-338, -310],
      [-688, -155],
      [558, -1032],
      [-455, -108],
      [-77, -598],
      [233, -1559],
      [390, -217],
    ],
    [
      [8430, 8044],
      [-78, 435],
      [130, 1093],
      [454, 543],
      [611, 334],
      [428, 1094],
      [507, 54],
      [260, 822],
      [1259, 311],
      [611, -202],
      [948, -101],
    ],
    [
      [11365, 19036],
      [234, -209],
      [948, -186],
      [507, 62],
      [-104, -458],
      [181, -527],
      [-90, -652],
      [506, -458],
      [598, -101],
      [311, -418],
    ],
    [[14456, 16089], [-26, -753], [-584, -939], [-208, -620], [-740, -574]],
    [
      [12898, 13203],
      [-884, 411],
      [312, 233],
      [-805, 240],
      [-65, 365],
      [-143, -16],
      [-286, 163],
      [-130, 310],
      [-298, 125],
      [156, 155],
      [-39, 380],
      [-247, 411],
      [221, 636],
      [-845, 318],
      [-558, 923],
      [-559, 39],
    ],
    [[11040, 30897], [-130, -233], [585, -1031], [1013, -380], [740, -489]],
    [[13248, 28764], [-1000, -737], [-831, -256]],
    [
      [11300, 26995],
      [377, -101],
      [247, -457],
      [545, -93],
      [-494, -1094],
      [-26, -652],
      [520, -628],
      [65, -644],
    ],
    [[12534, 23326], [-390, -23]],
    [
      [10144, 23466],
      [-117, 713],
      [182, 280],
      [-377, 830],
      [221, 380],
      [-636, 752],
      [78, 590],
      [-429, 357],
    ],
    [
      [13209, 40904],
      [767, -341],
      [493, -660],
      [-247, -589],
      [585, -202],
      [455, -620],
      [-338, -365],
      [13, -481],
    ],
    [[14937, 37646], [-533, 272], [-688, 15], [-883, -202], [-793, -442]],
    [[10261, 45279], [753, -93], [1442, 372], [2052, 241]],
    [
      [14508, 45799],
      [247, -985],
      [1026, -745],
      [494, -582],
      [-65, -457],
      [-1221, -349],
      [325, -675],
      [-1520, -512],
      [143, -380],
    ],
    [[13054, 34597], [1285, -93], [1260, -550], [312, -567], [403, -256]],
    [[16314, 33131], [311, -232], [-675, -644], [-208, -815]],
    [[15742, 31440], [-662, -465], [-883, -318], [-1105, 310], [-1389, -78]],
    [[15742, 31440], [429, -77]],
    [[16171, 31363], [688, -357], [78, -1265]],
    [[16937, 29741], [-740, -372], [-169, -380], [-546, -334]],
    [[15482, 28655], [-688, 179], [-1546, -70]],
    [[15482, 28655], [234, -760], [364, -388], [-442, -310]],
    [[15638, 27197], [-779, -372], [-2221, 7], [-1312, 241]],
    [[15638, 27197], [844, -163], [1546, -683], [637, -907], [220, 23]],
    [[18885, 25467], [-117, -279]],
    [
      [18768, 25188],
      [-389, -31],
      [-1442, 194],
      [-545, -24],
      [-156, -240],
      [-1923, -683],
      [-493, 171],
      [-559, -62],
      [-182, -256],
      [663, -388],
      [-390, -613],
      [-337, -186],
    ],
    [[13015, 23070], [-481, 256]],
    [[13677, 21139], [1572, 62], [285, 411], [585, 302]],
    [
      [16119, 21914],
      [1260, -372],
      [169, -574],
      [792, -194],
      [519, 675],
      [338, 116],
    ],
    [[19197, 21565], [-104, -613], [325, -77]],
    [
      [19418, 20875],
      [-65, -978],
      [1403, -690],
      [-377, -341],
      [-987, -218],
      [-156, -907],
      [507, -427],
      [104, -426],
    ],
    [[19847, 16888], [-2273, -47], [-780, -202]],
    [[16794, 16639], [-805, 140], [-766, -70], [-767, -620]],
    [
      [14937, 37646],
      [1403, -861],
      [714, 178],
      [1208, 55],
      [766, -210],
      [585, 155],
      [13, 365],
    ],
    [[19626, 37328], [1026, -147], [818, 31]],
    [[21470, 37212], [481, -1148]],
    [
      [21951, 36064],
      [-1468, -582],
      [688, -605],
      [-844, -543],
      [-286, 132],
      [-961, -156],
      [-2078, -1039],
      [-688, -140],
    ],
    [[13015, 23070], [454, -163], [390, 753], [1013, -39], [273, -605]],
    [[15145, 23016], [870, -729], [104, -373]],
    [
      [16794, 16639],
      [117, -644],
      [-312, -325],
      [39, -582],
      [-285, -1536],
      [117, -1078],
      [194, -722],
    ],
    [[16664, 11752], [-350, 186]],
    [[13560, 12427], [-662, 776]],
    [[14508, 45799], [1117, 248], [1871, -116], [610, 186]],
    [[18106, 46117], [130, -465], [403, -404], [-195, -147]],
    [
      [18444, 45101],
      [-65, -248],
      [662, -419],
      [-623, -140],
      [-13, -427],
      [545, -519],
      [-415, -187],
      [-65, -387],
      [-559, -349],
      [715, -799],
      [337, -575],
    ],
    [
      [18963, 41051],
      [-195, -170],
      [13, -683],
      [637, -1288],
      [-221, -1210],
      [429, -372],
    ],
    [[18768, 25188], [-623, -1094], [-805, -892]],
    [[17340, 23202], [-663, 62], [-272, -225], [-1260, -23]],
    [[17340, 23202], [1558, -1187], [299, -450]],
    [[16664, 11752], [1910, 342], [130, -132]],
    [[18704, 11962], [506, -163], [130, -411]],
    [
      [19340, 11388],
      [-753, -194],
      [-455, -318],
      [52, -264],
      [-701, -279],
      [480, -295],
      [-39, -791],
      [403, -567],
    ],
    [[18327, 8680], [-1039, -217]],
    [[16937, 29741], [1065, -77], [1442, 124], [403, -101]],
    [[19847, 29687], [870, -93]],
    [[20717, 29594], [-481, -1838], [-273, -148], [-129, -667], [259, -341]],
    [
      [20093, 26600],
      [-78, -411],
      [-558, 69],
      [-65, 481],
      [-961, -77],
      [493, -776],
      [-39, -419],
    ],
    [[21951, 36064], [1091, 108], [298, -139]],
    [
      [23340, 36033],
      [-610, -730],
      [571, -775],
      [403, -140],
      [338, -566],
      [-1273, -132],
      [-701, 217],
      [-416, -481],
      [-1364, -698],
      [-662, -830],
      [-377, -124],
    ],
    [[19249, 31774], [-1273, -396], [-1260, -124], [-545, 109]],
    [[19249, 31774], [429, -287], [883, -256], [558, 23], [715, -225]],
    [
      [21834, 31029],
      [260, -403],
      [-728, 62],
      [-792, -660],
      [-714, 93],
      [-13, -434],
    ],
    [[19847, 16888], [1376, -373]],
    [[21223, 16515], [65, -372], [-961, -768], [442, -287], [-364, -427]],
    [
      [20405, 14661],
      [-558, -364],
      [-754, -714],
      [-389, -559],
      [233, -628],
      [-233, -434],
    ],
    [[20093, 26600], [52, -761], [429, -31], [935, -853], [922, -209]],
    [
      [22431, 24746],
      [65, -404],
      [-247, -496],
      [208, -923],
      [-493, -210],
      [-754, 303],
      [-532, -233],
      [467, -271],
      [-493, -924],
      [-766, 311],
      [-117, -256],
      [-572, -78],
    ],
    [
      [19340, 11388],
      [870, 488],
      [1026, -419],
      [-195, -255],
      [975, -140],
      [194, -714],
    ],
    [
      [22210, 10348],
      [-987, -605],
      [234, -729],
      [-675, 39],
      [-1299, -644],
      [-585, 23],
      [-571, 248],
    ],
    [
      [18444, 45101],
      [610, -427],
      [338, 62],
      [909, -706],
      [-286, -419],
      [247, -387],
      [403, -132],
      [740, -605],
      [598, 100],
      [143, 613],
      [558, -39],
      [403, 218],
      [636, -241],
      [208, -489],
      [662, 63],
    ],
    [
      [24613, 42712],
      [-233, -466],
      [-650, -442],
      [-571, -1451],
      [298, -504],
      [-610, -15],
      [-325, -334],
    ],
    [
      [22522, 39500],
      [-221, 357],
      [-870, 0],
      [-221, 147],
      [195, 753],
      [-377, 357],
      [-454, -202],
      [-922, -47],
      [-689, 186],
    ],
    [
      [18106, 46117],
      [1416, 186],
      [675, 435],
      [896, 364],
      [104, 365],
      [429, 85],
      [416, 388],
      [337, 271],
      [793, 109],
      [337, 256],
      [948, -47],
    ],
    [
      [24457, 48529],
      [1286, -170],
      [-376, -962],
      [818, -908],
      [-78, -411],
      [208, -690],
      [1039, -838],
    ],
    [
      [27354, 44550],
      [-1676, 279],
      [-545, -39],
      [-598, -543],
      [793, -814],
      [91, -559],
    ],
    [[25419, 42874], [-806, -162]],
    [
      [20405, 14661],
      [1169, -85],
      [-52, -233],
      [546, -54],
      [1298, 396],
      [923, -350],
      [753, 179],
    ],
    [[25042, 14514], [65, 0]],
    [[25107, 14514], [65, -334]],
    [
      [25172, 14180],
      [-572, -806],
      [117, -412],
      [-701, -1140],
      [169, -1210],
      [-91, -357],
      [-598, -101],
      [-545, 194],
      [-741, 0],
    ],
    [[22522, 39500], [-325, -380], [-909, -683], [182, -1225]],
    [[22431, 24746], [948, -272], [403, 194]],
    [[23782, 24668], [611, 171], [1065, -140], [1039, 109], [402, -194]],
    [
      [26899, 24614],
      [-740, -458],
      [-546, -566],
      [-675, -427],
      [-571, -170],
      [181, -660],
      [-597, -535],
      [39, -272],
      [-559, -271],
      [-233, -427],
    ],
    [
      [23198, 20828],
      [-377, -209],
      [-662, 108],
      [-156, 342],
      [-1325, 46],
      [-416, 124],
      [-532, -418],
      [-312, 54],
    ],
    [[23198, 20828], [480, -450], [390, 55], [104, -776], [584, -559]],
    [
      [24756, 19098],
      [-389, -768],
      [-533, 249],
      [-247, -303],
      [-753, -411],
      [65, -163],
      [-481, -636],
      [234, -132],
      [-597, -333],
    ],
    [[22055, 16601], [-832, -86]],
    [[23340, 36033], [1182, -466], [923, -1094], [246, -682], [546, -644]],
    [[26237, 33147], [-429, -334]],
    [
      [25808, 32813],
      [-740, -101],
      [-857, -310],
      [-260, 78],
      [-1156, -272],
      [-779, -1272],
    ],
    [[22016, 30936], [-182, 93]],
    [[20717, 29594], [584, -450], [1260, -527], [481, 46], [987, -171]],
    [
      [24029, 28492],
      [247, -799],
      [-598, -38],
      [-117, -528],
      [130, -644],
      [-208, -1171],
      [299, -644],
    ],
    [[22016, 30936], [1740, -628], [896, 325], [650, 78]],
    [
      [25302, 30711],
      [740, -310],
      [195, -365],
      [571, -171],
      [1338, -861],
      [961, -15],
      [-13, 248],
      [1065, -70],
      [663, 163],
    ],
    [[30822, 29330], [-234, -1171], [130, -334]],
    [[30718, 27825], [-598, -155], [-662, -403], [-416, 209], [-584, -473]],
    [[28458, 27003], [-2416, 683], [-1338, -8], [-13, 481], [-662, 333]],
    [
      [22055, 16601],
      [1052, -194],
      [285, 364],
      [390, -232],
      [1039, 15],
      [416, -411],
      [-26, -512],
      [-468, -528],
      [299, -589],
    ],
    [
      [25419, 42874],
      [337, -162],
      [299, -590],
      [286, 124],
      [766, -954],
      [792, -256],
      [-779, -528],
      [727, -496],
      [390, -93],
    ],
    [
      [28237, 39919],
      [-1182, -225],
      [-493, -590],
      [-754, 24],
      [65, -1032],
      [546, -815],
      [753, -85],
      [221, -1606],
      [-208, -643],
    ],
    [
      [27185, 34947],
      [-442, -109],
      [247, -628],
      [338, -163],
      [78, -892],
      [-1000, -179],
      [-169, 171],
    ],
    [[25808, 32813], [351, -644], [-636, -682], [-689, -287], [468, -489]],
    [
      [24756, 19098],
      [663, -201],
      [-130, -411],
      [467, -156],
      [676, 148],
      [389, -124],
      [468, 287],
      [-273, 442],
      [1091, 729],
      [689, 295],
      [662, 54],
      [468, -372],
      [1286, -520],
      [1013, 303],
      [584, 310],
      [1793, 504],
    ],
    [
      [34602, 20386],
      [272, -900],
      [-259, -760],
      [-494, -209],
      [-182, -505],
      [-273, -46],
      [-181, -644],
      [-416, -23],
      [-221, -435],
      [117, -791],
      [-143, -442],
    ],
    [[32822, 15631], [-844, -442]],
    [[31978, 15189], [-663, -233], [-1610, 396]],
    [
      [29705, 15352],
      [-572, 240],
      [-402, 636],
      [-533, 70],
      [-1000, -628],
      [-1221, -78],
      [-299, -155],
      [-324, -628],
    ],
    [[25354, 14809], [-247, -295]],
    [[26899, 24614], [767, 395]],
    [
      [27666, 25009],
      [688, -667],
      [78, -333],
      [1026, -179],
      [714, 24],
      [2325, -210],
      [910, 148],
      [688, -140],
    ],
    [[34095, 23652], [403, -528]],
    [[34498, 23124], [-247, -294], [415, -1234], [-103, -419]],
    [[34563, 21177], [39, -791]],
    [[27471, 74105], [13, -217]],
    [[27484, 73888], [-91, -465]],
    [[27393, 73423], [-572, -683], [-883, -442]],
    [
      [25938, 72298],
      [-402, 527],
      [532, 567],
      [299, 690],
      [-1325, 504],
      [-909, 124],
      [-754, -77],
      [-13, 240],
      [806, 1187],
      [779, 47],
      [1792, -241],
      [260, -845],
      [-273, -489],
      [741, -427],
    ],
    [[28458, 27003], [-26, -473], [-753, -1024], [-13, -497]],
    [
      [24457, 48529],
      [689, 606],
      [1091, 279],
      [312, 582],
      [-533, 194],
      [481, 256],
      [532, 15],
      [416, 388],
      [-364, 279],
      [741, 365],
    ],
    [[27822, 51493], [1181, -1482]],
    [
      [29003, 50011],
      [702, -566],
      [480, -760],
      [767, -636],
      [688, -287],
      [1013, -1094],
      [234, -39],
    ],
    [
      [32887, 46629],
      [-390, -667],
      [871, -706],
      [-923, -140],
      [-545, -473],
      [-364, 70],
      [-701, -466],
      [156, -271],
      [-572, -147],
    ],
    [[30419, 43829], [-1143, -287], [-1143, 705], [-779, 303]],
    [
      [30419, 43829],
      [52, -326],
      [1234, -380],
      [208, -280],
      [-130, -535],
      [338, -202],
      [156, -845],
      [376, -186],
      [-623, -551],
    ],
    [
      [32030, 40524],
      [-1286, -434],
      [-1182, 38],
      [-481, -263],
      [-91, -621],
      [-753, 675],
    ],
    [
      [27185, 34947],
      [1299, -86],
      [143, -543],
      [675, 124],
      [-299, -519],
      [910, -86],
      [441, -349],
    ],
    [[30354, 33488], [-584, -799], [1390, 186], [753, -915]],
    [[31913, 31960], [-663, -1396], [325, -497]],
    [[31575, 30067], [-753, -737]],
    [[25354, 14809], [1065, 333], [2169, -349]],
    [[28588, 14793], [-52, -380], [325, -652], [870, -690]],
    [[29731, 13071], [-104, -194], [-1637, 473]],
    [[27990, 13350], [-91, 512], [-506, 210], [-312, -295], [-1117, -155]],
    [[25964, 13622], [39, 155], [-831, 403]],
    [[26003, 72228], [442, -93], [1091, 442]],
    [
      [27536, 72577],
      [779, 16],
      [468, -179],
      [156, 489],
      [662, 318],
      [-156, 194],
    ],
    [
      [29445, 73415],
      [766, -86],
      [-103, -1117],
      [-468, -279],
      [195, -566],
      [844, -202],
      [610, 179],
    ],
    [[31289, 71344], [-402, -396], [571, -365], [-779, -705]],
    [
      [30679, 69878],
      [-338, 131],
      [-1506, -163],
      [-351, -341],
      [-1130, -248],
      [-766, 15],
      [-936, -566],
    ],
    [
      [25652, 68706],
      [-402, 1016],
      [480, 1040],
      [-168, 194],
      [467, 380],
      [-26, 892],
    ],
    [[29705, 15352], [-805, -613], [-312, 54]],
    [
      [30679, 69878],
      [559, -435],
      [675, -62],
      [-104, -287],
      [416, -504],
      [-598, -466],
      [-221, 86],
      [-1454, -807],
      [-741, -178],
      [-831, -427],
      [-1520, -318],
    ],
    [[26860, 66480], [-39, 659], [-389, 140], [-182, 737], [-598, 690]],
    [[32030, 40524], [714, -504]],
    [
      [32744, 40020],
      [-325, -683],
      [-38, -543],
      [-364, -411],
      [104, -590],
      [-117, -1016],
      [-364, -473],
      [169, -869],
      [572, -512],
    ],
    [
      [32381, 34923],
      [0, -264],
      [-650, -372],
      [442, -520],
      [-143, -387],
      [-1260, -156],
      [-416, 264],
    ],
    [[27990, 13350], [-883, -225], [-909, -38], [-234, 535]],
    [
      [27471, 74105],
      [532, 225],
      [767, 993],
      [740, 202],
      [364, -171],
      [428, 466],
      [-104, 589],
      [598, 481],
      [610, 163],
    ],
    [[31406, 77053], [1598, -760], [403, -574], [1571, -551]],
    [[34978, 75168], [-324, -605]],
    [
      [34654, 74563],
      [-520, 240],
      [-1143, -791],
      [-623, -70],
      [13, -682],
      [-611, -551],
      [377, -504],
      [-117, -349],
    ],
    [[32030, 71856], [-987, -318], [246, -194]],
    [[29445, 73415], [273, 520], [-1871, 93], [-363, -140]],
    [[27393, 73423], [416, -536], [-273, -310]],
    [[26003, 72228], [-65, 70]],
    [
      [28679, 58909],
      [1000, -39],
      [312, -279],
      [2493, -1063],
      [1014, -504],
      [974, -31],
      [130, -272],
      [-559, -520],
      [1831, 381],
    ],
    [
      [35874, 56582],
      [1195, 504],
      [1143, 15],
      [26, 349],
      [442, 357],
      [1520, -349],
    ],
    [[40200, 57458], [428, -558]],
    [[40628, 56900], [-1961, -978], [-1831, -993]],
    [
      [36836, 54929],
      [-1040, 124],
      [-350, 225],
      [-805, 109],
      [-1130, 450],
      [-1546, -171],
      [-883, 349],
      [-611, -163],
      [-688, -706],
    ],
    [[29783, 55146], [-767, 435], [-428, -117], [-299, -674]],
    [[28289, 54790], [-26, -70]],
    [[28263, 54720], [-766, 535]],
    [
      [27497, 55255],
      [-234, 39],
      [-403, 170],
      [208, 722],
      [312, 333],
      [-156, 551],
      [507, 287],
      [298, 497],
      [637, 512],
      [13, 543],
    ],
    [
      [32030, 71856],
      [325, 163],
      [1104, -70],
      [623, 186],
      [390, -140],
      [337, -551],
      [806, 148],
    ],
    [[35615, 71592], [1363, -543], [767, -1117]],
    [
      [37745, 69932],
      [-624, 139],
      [-1337, -287],
      [-1247, -837],
      [-377, -70],
      [-727, -504],
      [-130, -381],
      [-935, -178],
      [-299, -636],
      [-533, -202],
      [273, -1008],
    ],
    [[31809, 65968], [-844, -54]],
    [
      [30965, 65914],
      [-598, 100],
      [-480, -178],
      [-832, -23],
      [-1000, 395],
      [-1195, 272],
    ],
    [[27497, 55255], [792, -465]],
    [[29783, 55146], [286, -418], [1350, -388], [1741, -706]],
    [
      [33160, 53634],
      [273, -117],
      [-1052, -729],
      [-221, -512],
      [-429, 210],
      [-688, -8],
      [0, 302],
      [-1585, 419],
    ],
    [[29458, 53199], [-130, 691], [-740, 333], [-325, 497]],
    [
      [30718, 27825],
      [1338, -294],
      [649, -412],
      [637, -7],
      [376, -326],
      [312, 139],
    ],
    [
      [34030, 26925],
      [649, -31],
      [182, -372],
      [832, -116],
      [103, -357],
      [-649, -962],
      [208, -527],
      [-1078, -388],
      [-182, -520],
    ],
    [[33160, 53634], [1156, -55], [441, 148], [819, -78], [493, 528]],
    [[36069, 54177], [780, -411], [1298, -520], [312, 39]],
    [[38459, 53285], [741, -280]],
    [[39200, 53005], [-1105, -1473], [-636, -272], [-2234, -341], [403, -644]],
    [[35628, 50275], [-1559, 77], [26, -1062]],
    [
      [34095, 49290],
      [-1974, 1078],
      [-1156, -233],
      [-845, 241],
      [-415, -295],
      [-702, -70],
    ],
    [[27822, 51493], [649, 279], [-130, 256], [636, 372], [481, 799]],
    [[31978, 15189], [-26, -318], [909, -1296], [650, -395]],
    [
      [33511, 13180],
      [-1143, -148],
      [-468, 613],
      [-714, -47],
      [-793, 373],
      [-558, -497],
      [-104, -403],
    ],
    [[32251, 62997], [636, -504]],
    [
      [32887, 62493],
      [-13, -349],
      [779, -939],
      [273, -667],
      [507, -466],
      [480, 194],
      [871, -977],
      [-1208, -1024],
      [714, -272],
      [-598, -302],
      [247, -194],
      [845, -39],
      [90, -876],
    ],
    [
      [28679, 58909],
      [-78, 682],
      [428, 241],
      [858, 132],
      [766, 504],
      [-455, 512],
      [572, 357],
      [1182, 54],
      [273, 473],
      [-377, 636],
      [403, 497],
    ],
    [[34095, 49290], [-143, -629], [286, -457], [-273, -629], [143, -388]],
    [[34108, 47187], [-740, -589], [-481, 31]],
    [[32381, 34923], [1272, -675], [78, -225], [1442, 303], [585, 23]],
    [
      [35758, 34349],
      [1091, 31],
      [1000, -194],
      [1376, 605],
      [494, 78],
      [468, -667],
      [467, -31],
      [598, 256],
    ],
    [
      [41252, 34427],
      [208, -900],
      [-1040, -729],
      [-532, 232],
      [-1026, -473],
      [-1520, 210],
      [-78, -179],
    ],
    [
      [37264, 32588],
      [-532, 334],
      [-948, 23],
      [-247, 194],
      [-507, -357],
      [-688, -232],
      [169, -319],
    ],
    [[34511, 32231], [-910, -240], [-1311, 85], [-377, -116]],
    [[36836, 54929], [-611, -225], [-156, -527]],
    [[33160, 81180], [935, -768]],
    [[34095, 80412], [-208, -380], [-714, -155], [-65, -303], [-585, -233]],
    [
      [32523, 79341],
      [-467, 179],
      [-1793, 938],
      [-39, 94],
      [637, -140],
      [1974, 551],
      [325, 217],
    ],
    [
      [34108, 47187],
      [195, -232],
      [753, 93],
      [377, -140],
      [701, 155],
      [481, -442],
      [896, 458],
    ],
    [[37511, 47079], [91, -124], [987, 240], [1546, -178]],
    [[40135, 47017], [-78, -442]],
    [
      [40057, 46575],
      [-857, 93],
      [-1156, -714],
      [493, -845],
      [727, 170],
      [442, -77],
    ],
    [
      [39706, 45202],
      [-1156, -458],
      [65, -419],
      [481, -791],
      [493, -473],
      [-480, -652],
      [428, -279],
      [143, -489],
      [-195, -302],
      [-766, -435],
      [-1169, -364],
    ],
    [[37550, 40540], [-1013, -125], [-766, -279], [-494, 140], [-1961, -357]],
    [[33316, 39919], [-572, 101]],
    [[31809, 65968], [805, -31], [1780, -380], [1195, -8]],
    [[35589, 65549], [117, -295], [766, -489]],
    [[36472, 64765], [-338, -876], [-636, -318]],
    [[35498, 63571], [-234, -745], [-442, -302], [-1441, -249], [-494, 218]],
    [
      [32251, 62997],
      [-26, 225],
      [-715, 613],
      [-350, 892],
      [-702, 574],
      [507, 613],
    ],
    [[31575, 30067], [1273, -202], [-221, -527], [1000, -1140], [702, -186]],
    [[34329, 28012], [-286, -419], [-13, -668]],
    [
      [34511, 32231],
      [727, -806],
      [403, 77],
      [389, -605],
      [299, -23],
      [-338, -830],
      [-402, -411],
      [-52, -373],
      [584, -147],
    ],
    [[36121, 29113], [299, -566]],
    [[36420, 28547], [-585, 62], [-935, -179], [-571, -418]],
    [[31406, 77053], [1312, 341]],
    [
      [32718, 77394],
      [494, 427],
      [870, -62],
      [247, -272],
      [1091, -240],
      [1130, -365],
      [1571, -271],
    ],
    [[38121, 76611], [-168, -279], [792, -559]],
    [[38745, 75773], [91, -101]],
    [[38836, 75672], [-130, -124]],
    [[38706, 75548], [-701, -271]],
    [[38005, 75277], [-598, -8]],
    [[37407, 75269], [-922, 15], [-1299, 179], [-208, -295]],
    [[37745, 69932], [428, -202]],
    [[38173, 69730], [143, -77]],
    [
      [38316, 69653],
      [-649, -567],
      [-792, -194],
      [-468, -333],
      [-675, -916],
      [-143, -2094],
    ],
    [[38745, 69513], [1610, -101]],
    [[40355, 69412], [-688, -543]],
    [[39667, 68869], [-662, 163], [-260, 481]],
    [
      [33316, 39919],
      [532, -248],
      [0, -272],
      [507, -892],
      [1416, -605],
      [-754, -628],
      [182, -1249],
      [-117, -559],
      [208, -535],
      [468, -582],
    ],
    [[34654, 74563], [1675, -1443]],
    [[36329, 73120], [-26, -380], [-494, -264], [-194, -884]],
    [
      [32822, 15631],
      [1364, -365],
      [623, 16],
      [416, 434],
      [325, -108],
      [1065, 287],
      [662, 574],
      [481, 178],
      [260, 403],
      [39, 846],
    ],
    [[38057, 17896], [363, -496], [286, -970], [377, -171]],
    [
      [39083, 16259],
      [-1078, -814],
      [753, -536],
      [1351, 737],
      [1013, -395],
      [234, -450],
      [1234, -861],
      [974, -241],
      [91, -442],
      [-494, -233],
      [-766, 117],
      [-429, -435],
      [-779, 125],
      [-1858, 512],
      [-610, 85],
      [-117, -799],
      [-1675, 31],
      [-585, 217],
      [-597, 636],
      [-1754, -132],
      [-480, -201],
    ],
    [[34095, 80412], [1961, -551], [689, 116], [1143, -279]],
    [
      [37888, 79698],
      [-663, -744],
      [-273, -885],
      [520, -318],
      [78, -341],
      [844, -629],
      [-273, -170],
    ],
    [[32718, 77394], [-441, 303], [1324, 830], [-363, 481], [-715, 333]],
    [
      [35498, 63571],
      [961, -1249],
      [117, -411],
      [532, -357],
      [-52, -675],
      [858, -1226],
      [363, -31],
      [1195, -1055],
      [767, -1093],
    ],
    [[40239, 57474], [-39, -16]],
    [
      [34563, 21177],
      [831, 171],
      [1390, -109],
      [-520, -961],
      [91, -443],
      [-247, -271],
      [1299, -47],
      [-13, -504],
      [637, 124],
    ],
    [[38031, 19137], [-325, -574], [351, -667]],
    [
      [33160, 81180],
      [532, 411],
      [987, -442],
      [793, 395],
      [-78, 233],
      [675, 528],
      [117, 380],
      [494, 527],
    ],
    [
      [36680, 83212],
      [766, -147],
      [948, -597],
      [844, 504],
      [65, 372],
      [988, 520],
    ],
    [[40291, 83864], [1987, -279], [662, -311], [455, 31], [961, -450]],
    [[44356, 82855], [-208, -131], [1455, -1389], [-130, -248]],
    [[45473, 81087], [-1325, -117], [-1143, -325], [-1169, -24]],
    [[41836, 80621], [-610, -155]],
    [[41226, 80466], [-884, -481], [-1078, -62], [-519, 86], [-857, -311]],
    [
      [37550, 40540],
      [1039, -629],
      [364, -473],
      [675, 0],
      [572, -372],
      [-39, -365],
      [428, -434],
      [78, -543],
      [312, -256],
      [649, -1172],
      [169, -721],
      [520, -698],
      [-987, -202],
      [-78, -248],
    ],
    [
      [35628, 50275],
      [844, 8],
      [870, -334],
      [1961, 23],
      [-220, -651],
      [-884, -908],
      [-1208, -395],
      [130, -629],
      [390, -310],
    ],
    [
      [36420, 28547],
      [-52, -256],
      [766, -784],
      [1143, 24],
      [1091, 232],
      [-26, -357],
      [884, -1194],
      [-286, -31],
      [117, -473],
      [-364, -334],
      [-429, 23],
      [-363, -450],
      [467, -737],
    ],
    [[39368, 24210], [-597, -535], [-546, -155], [403, -450]],
    [
      [38628, 23070],
      [-1078, -132],
      [-714, -496],
      [-585, -140],
      [-169, 341],
      [338, 233],
      [-325, 318],
      [-857, 210],
      [-740, -280],
    ],
    [[38628, 23070], [649, -807], [2079, 303], [1883, 147]],
    [
      [43239, 22713],
      [65, -1024],
      [-1507, -108],
      [169, -481],
      [-1727, -279],
      [376, -877],
      [481, -178],
      [-338, -551],
      [182, -357],
      [818, 109],
      [416, -489],
    ],
    [
      [42174, 18478],
      [13, -101],
      [-1260, -496],
      [-636, 139],
      [-442, -147],
      [-662, 248],
      [-39, 380],
      [-637, 644],
      [-480, -8],
    ],
    [
      [37264, 32588],
      [922, -147],
      [91, -1133],
      [-363, -318],
      [104, -892],
      [-338, -147],
      [156, -528],
      [-715, 39],
      [-1000, -349],
    ],
    [[37407, 75269], [182, -846], [403, -178], [-26, -737], [-1078, -535]],
    [[36888, 72973], [-559, 147]],
    [[39200, 53005], [1065, -651], [1402, -85]],
    [
      [41667, 52269],
      [78, -179],
      [1273, -1078],
      [715, -171],
      [831, -496],
      [78, -225],
    ],
    [[44642, 50120], [117, -365], [545, -520]],
    [[45304, 49235], [-156, 8]],
    [
      [45148, 49243],
      [-610, -504],
      [-974, -39],
      [-1624, -644],
      [-662, -605],
      [-1013, -147],
      [-130, -287],
    ],
    [
      [36888, 72973],
      [1766, -986],
      [468, -349],
      [-442, -667],
      [-13, -527],
      [-494, -714],
    ],
    [[36472, 64765], [65, 86]],
    [[36537, 64851], [182, -241], [1363, -496], [884, -54]],
    [[38966, 64060], [156, -396]],
    [
      [39122, 63664],
      [-546, 8],
      [-494, -543],
      [325, -644],
      [-325, -667],
      [403, -132],
      [416, -784],
      [402, -69],
      [1001, -1009],
      [1805, -1419],
    ],
    [[42109, 58405], [-611, -125], [-337, -659], [-922, -147]],
    [[38316, 69653], [429, -140]],
    [[39667, 68869], [727, -233]],
    [[40394, 68636], [-1078, -488], [-545, -629], [-26, -287]],
    [[38745, 67232], [13, -372], [-403, -1032], [52, -341], [-1870, -636]],
    [[40628, 56900], [598, -202], [78, -520], [519, -566]],
    [[41823, 55612], [-1506, -621], [-325, -349], [-883, -372], [-650, -985]],
    [[39109, 85671], [207, -682], [-402, -442], [714, -202], [663, -481]],
    [
      [36680, 83212],
      [-273, 349],
      [416, 396],
      [129, 574],
      [442, 147],
      [364, 443],
      [831, 193],
      [520, 357],
    ],
    [[38005, 75277], [519, -1637], [1286, 349]],
    [[39810, 73989], [779, -1094], [961, -1101]],
    [
      [41550, 71794],
      [-402, -210],
      [-52, -403],
      [-520, -753],
      [-259, 86],
      [-858, -225],
      [-714, -776],
    ],
    [
      [41226, 80466],
      [247, -101],
      [-299, -1256],
      [-533, -264],
      [91, -194],
      [-974, -1264],
      [-533, -373],
      [-480, -1241],
    ],
    [
      [42174, 18478],
      [714, 139],
      [1221, -325],
      [896, -365],
      [-26, -427],
      [-1143, -504],
      [-2883, -271],
      [-403, -225],
      [-844, -47],
      [-623, -194],
    ],
    [[38706, 75548], [1559, -1187]],
    [[40265, 74361], [-455, -372]],
    [
      [40057, 46575],
      [1636, -218],
      [533, -193],
      [299, 186],
      [987, -93],
      [571, 612],
      [702, 225],
      [-598, 427],
      [1000, 272],
      [-208, 387],
      [728, 404],
      [-559, 659],
    ],
    [
      [45304, 49235],
      [676, -69],
      [636, -668],
      [935, 156],
      [948, -396],
      [1286, -1171],
      [468, -986],
      [545, -147],
    ],
    [
      [50798, 45954],
      [-441, -194],
      [0, -411],
      [-676, -202],
      [-13, -527],
      [-1260, 85],
      [-1337, -46],
      [-364, 279],
      [-1169, -85],
      [-831, 124],
      [-338, -388],
      [-494, -47],
      [195, -613],
      [-1143, -566],
      [-299, 373],
      [-714, 240],
      [-52, 271],
      [546, 342],
      [-611, 341],
      [-662, -8],
      [-1429, 280],
    ],
    [
      [39122, 63664],
      [168, -442],
      [-246, -473],
      [597, -218],
      [-104, -450],
      [1104, -884],
      [-117, -271],
      [403, -505],
      [935, -744],
      [455, 232],
      [1351, -535],
      [688, -108],
    ],
    [[44356, 59266], [-195, -272], [429, -535]],
    [[44590, 58459], [-416, -101]],
    [[44174, 58358], [-1221, -295], [-844, 342]],
    [
      [39368, 24210],
      [338, -46],
      [1572, 209],
      [1182, 349],
      [2260, 47],
      [480, -760],
      [533, -194],
      [39, -791],
      [-1754, -272],
      [-779, -39],
    ],
    [[41823, 55612], [442, 163], [1091, -1133], [390, -201]],
    [[43746, 54441], [129, -117]],
    [[43875, 54324], [1455, -1109]],
    [[45330, 53215], [-1597, -427], [-1663, -644], [-403, 125]],
    [[40394, 68636], [1053, -77], [753, -512], [987, -210]],
    [
      [43187, 67837],
      [-520, -465],
      [-389, 0],
      [-195, -427],
      [-844, -186],
      [-169, -729],
      [-1260, 202],
      [-507, 1024],
      [-558, -24],
    ],
    [[38836, 75672], [844, 520], [1520, -628], [1039, 248], [1338, 620]],
    [[43577, 76432], [1337, -923], [533, -194], [429, -527]],
    [[45876, 74788], [-793, -411], [-220, -427], [-455, -163]],
    [[44408, 73787], [-805, -170]],
    [
      [43603, 73617],
      [-273, 612],
      [-922, 47],
      [-104, 396],
      [-1702, 77],
      [-337, -388],
    ],
    [[41550, 71794], [611, 403], [870, 256]],
    [
      [43031, 72453],
      [130, -186],
      [831, -248],
      [208, -675],
      [779, -194],
      [78, -186],
    ],
    [
      [45057, 70964],
      [-117, -109],
      [-1169, 202],
      [-402, -334],
      [-1871, -334],
      [-610, -845],
      [-286, -140],
    ],
    [[40602, 69404], [-247, 8]],
    [
      [41836, 80621],
      [117, -473],
      [624, -364],
      [-117, -512],
      [571, -668],
      [-805, -589],
      [65, -458],
      [389, -450],
      [897, -675],
    ],
    [
      [38966, 64060],
      [1000, -365],
      [675, 54],
      [857, -132],
      [598, -659],
      [468, 62],
      [467, -240],
    ],
    [
      [43031, 62780],
      [-182, -613],
      [1065, -683],
      [-337, -217],
      [1221, -753],
      [13, -845],
      [-455, -403],
    ],
    [
      [39109, 85671],
      [78, 0],
      [1272, 442],
      [182, -186],
      [1182, 101],
      [481, 326],
      [1312, -248],
      [1247, 279],
      [311, -636],
      [1520, -1102],
      [26, -124],
    ],
    [[46720, 84523], [-831, -201]],
    [[45889, 84322], [-1234, 93], [-961, -505], [1207, -1202]],
    [[44901, 82708], [-545, 147]],
    [
      [40602, 69404],
      [1572, -217],
      [1779, 124],
      [1117, 528],
      [182, -31],
      [1117, 543],
    ],
    [
      [46369, 70351],
      [1351, -1110],
      [-987, -814],
      [-1195, -124],
      [-546, 147],
      [-311, -419],
      [-494, 8],
      [-558, -302],
      [-442, 100],
    ],
    [[43603, 73617], [-572, -1164]],
    [
      [44174, 58358],
      [831, -427],
      [-649, -473],
      [273, -132],
      [-468, -605],
      [182, -582],
      [377, -356],
      [-715, -613],
      [-259, -729],
    ],
    [[45057, 70964], [455, 85], [961, -466]],
    [[46473, 70583], [-104, -232]],
    [[45330, 53215], [104, -489], [1195, 497], [403, -1567]],
    [[47032, 51656], [-377, -730], [-727, -349], [-702, -566], [-584, 109]],
    [
      [45473, 81087],
      [649, 248],
      [663, -194],
      [727, 132],
      [1091, 504],
      [364, 0],
    ],
    [
      [48967, 81777],
      [480, -473],
      [169, -574],
      [481, -372],
      [480, -683],
      [-25, -512],
      [-559, -411],
      [117, -419],
    ],
    [
      [50110, 78333],
      [-611, -217],
      [-2013, -435],
      [-948, -806],
      [221, -435],
      [-195, -341],
      [597, -939],
      [13, -326],
    ],
    [[47174, 74834], [-766, 86], [-532, -132]],
    [
      [43031, 62780],
      [766, -70],
      [559, 457],
      [857, -248],
      [403, 55],
      [2065, -730],
      [831, -558],
      [858, -388],
      [1649, -209],
    ],
    [[51019, 61089], [52, -505]],
    [
      [51071, 60584],
      [-883, -38],
      [78, -675],
      [-299, -644],
      [338, -799],
      [104, -660],
      [-520, -131],
      [156, 667],
      [-481, 170],
      [-78, 474],
      [-1013, 23],
      [-1714, 170],
      [-1468, -38],
      [104, -280],
      [-403, -457],
    ],
    [[44992, 58366], [-402, 93]],
    [[44408, 73787], [844, -675], [286, -403]],
    [[45538, 72709], [364, -403], [1013, -1521]],
    [[46915, 70785], [-442, -202]],
    [[45889, 84322], [-1052, -1141], [844, -349], [-91, -233], [-689, 109]],
    [[44992, 58366], [338, -388], [792, -109], [637, -442], [1740, -737]],
    [
      [48499, 56690],
      [-532, -799],
      [-1390, -520],
      [-753, -124],
      [-442, -310],
      [-948, -287],
      [-559, -326],
    ],
    [
      [48499, 56690],
      [1039, 62],
      [-233, 667],
      [376, -23],
      [533, -582],
      [714, -85],
      [1520, 147],
    ],
    [[52448, 56876], [156, 70], [1065, -434]],
    [
      [53669, 56512],
      [-883, -303],
      [610, -558],
      [-247, -155],
      [-402, -862],
      [-65, -659],
      [610, -116],
      [961, -830],
      [-143, -411],
      [-649, -349],
      [-779, 767],
      [-364, -131],
      [-598, 892],
      [-519, -349],
      [260, -450],
      [-1052, -466],
      [1000, -915],
      [-442, -194],
      [221, -341],
      [-468, -187],
    ],
    [
      [50720, 50895],
      [-311, 319],
      [-390, -187],
      [-1091, 124],
      [-1182, 520],
      [-714, -15],
    ],
    [
      [46720, 84523],
      [961, -628],
      [169, -442],
      [649, -489],
      [377, 8],
      [636, -566],
      [143, -443],
    ],
    [[49655, 81963], [-688, -186]],
    [[47174, 74834], [728, -131], [1325, 170]],
    [
      [49227, 74873],
      [298, -23],
      [312, -667],
      [455, 0],
      [2961, -365],
      [0, -582],
      [429, -729],
      [65, -589],
    ],
    [[53747, 71918], [-1104, 263], [-923, -341], [-662, 155]],
    [
      [51058, 71995],
      [-636, 117],
      [-1325, -194],
      [-1052, 279],
      [-741, 62],
      [-233, 303],
      [-819, 356],
      [-714, -209],
    ],
    [[50720, 50895], [468, -814]],
    [
      [51188, 50081],
      [961, -1040],
      [-519, -512],
      [1272, -287],
      [351, -628],
      [-415, -970],
    ],
    [[52838, 46644], [-741, -480], [-805, -241], [-494, 31]],
    [[51071, 60584], [948, -1567], [-52, -481], [481, -1660]],
    [
      [51058, 71995],
      [-273, -217],
      [-1831, -279],
      [-1585, -8],
      [65, -644],
      [-519, -62],
    ],
    [[50110, 78333], [182, -47], [870, -1031], [597, -435]],
    [[51759, 76820], [-974, -419], [91, -380], [-428, -597], [-1221, -551]],
    [[49655, 81963], [494, 155]],
    [
      [50149, 82118],
      [351, -566],
      [831, -620],
      [623, -1707],
      [442, -512],
      [805, -248],
      [572, 132],
      [1662, -442],
      [117, -249],
    ],
    [[55552, 77906], [-91, -217], [689, -589]],
    [[56150, 77100], [-767, -435]],
    [
      [55383, 76665],
      [-441, -411],
      [-1221, 78],
      [-663, 457],
      [-545, 171],
      [-754, -140],
    ],
    [[55383, 76665], [728, -1350], [65, -294], [610, -528], [572, -178]],
    [[57358, 74315], [-143, -1296], [-1182, 179], [-260, -885], [-1000, -248]],
    [[54773, 72065], [-1026, -147]],
    [
      [51630, 83282],
      [1000, -597],
      [65, -241],
      [2714, -1768],
      [520, 0],
      [-65, -311],
      [377, -256],
      [415, 62],
    ],
    [
      [56656, 80171],
      [-753, -620],
      [597, -450],
      [-519, -287],
      [441, -458],
      [-870, -450],
    ],
    [[50149, 82118], [714, 854], [767, 310]],
    [[53669, 56512], [948, 395], [1286, 0], [1351, 380]],
    [
      [57254, 57287],
      [649, -651],
      [1143, 85],
      [598, -271],
      [-78, -179],
      [714, -775],
      [494, 15],
      [155, -271],
      [767, -156],
      [-974, -550],
      [194, -799],
      [-922, -419],
      [-363, -512],
      [-1845, -567],
      [-610, 396],
      [-871, -683],
    ],
    [
      [56305, 51950],
      [-545, 24],
      [-1156, -202],
      [-714, -1001],
      [-1052, -574],
      [-416, 132],
      [-1234, -248],
    ],
    [
      [51019, 61089],
      [2026, 411],
      [416, 217],
      [1065, 209],
      [1883, -457],
      [533, -1265],
      [1169, -93],
      [-533, -558],
      [676, -1125],
      [39, -357],
      [-364, -613],
      [-675, -171],
    ],
    [
      [56305, 51950],
      [1001, -1411],
      [597, -574],
      [-701, -629],
      [-247, -442],
      [195, -357],
      [-1078, -357],
      [194, -186],
      [-623, -217],
      [-766, -39],
      [-754, -326],
      [-532, -814],
      [-753, 46],
    ],
    [
      [54539, 85609],
      [1117, -876],
      [1182, -636],
      [1104, -931],
      [-273, -217],
      [767, -497],
      [9754, -202],
    ],
    [[68190, 82250], [-559, -465]],
    [
      [67631, 81785],
      [-7663, -116],
      [-1506, -838],
      [-221, -512],
      [-650, 248],
      [-441, -372],
      [-494, -24],
    ],
    [[51630, 83282], [974, 768], [1351, 1008], [649, 241], [-65, 310]],
    [
      [57487, 87479],
      [767, -481],
      [857, -295],
      [1169, -659],
      [182, 23],
      [1831, -489],
      [533, -411],
      [5897, -2482],
    ],
    [[68723, 82685], [-533, -435]],
    [
      [54539, 85609],
      [78, 900],
      [610, 47],
      [819, 194],
      [246, 589],
      [637, 411],
      [558, -271],
    ],
    [[57358, 74315], [1506, 7], [3689, -481]],
    [[62553, 73841], [-403, -1373], [91, -2234]],
    [
      [62241, 70234],
      [-4221, 404],
      [-1182, 209],
      [-91, -132],
      [-1624, 621],
      [-350, 729],
    ],
    [[56150, 77100], [1506, 147], [-26, -799], [702, 132], [4844, -605]],
    [[63176, 75975], [-623, -2134]],
    [[67631, 81785], [-1324, -1117]],
    [[66307, 80668], [-2364, -1986], [-442, -1590]],
    [[63501, 77092], [-325, -1117]],
    [[57487, 87479], [273, 178], [1104, 0], [1546, 590], [195, 395]],
    [[60605, 88642], [675, -434], [1052, -403]],
    [[62332, 87805], [299, -256], [1156, -334], [1169, -636], [4416, -3359]],
    [[69372, 83220], [-649, -535]],
    [
      [71463, 93111],
      [13, -505],
      [507, -116],
      [1480, 729],
      [1026, -628],
      [-259, -256],
      [-546, 93],
      [-377, -1009],
      [-610, -364],
      [-1364, 295],
      [-1519, 620],
      [-1040, -31],
      [78, -853],
      [-519, 163],
      [-520, -442],
      [104, -349],
      [-441, -412],
    ],
    [[67476, 90046], [-1442, -15], [-598, -326]],
    [
      [65436, 89705],
      [-376, -77],
      [-481, -606],
      [-922, -364],
      [-585, -559],
      [-740, -294],
    ],
    [
      [60605, 88642],
      [-546, 714],
      [39, 496],
      [442, -23],
      [39, 1862],
      [1026, 54],
      [1117, -232],
      [779, 23],
      [2299, 364],
      [1104, 489],
      [987, 16],
      [935, 325],
      [26, 225],
      [1442, 187],
      [909, -70],
      [260, 39],
    ],
    [
      [65436, 89705],
      [520, -458],
      [13, -620],
      [740, -853],
      [26, -404],
      [-428, -558],
      [675, -923],
      [2741, -2397],
    ],
    [[69723, 83492], [-351, -272]],
    [
      [63501, 77092],
      [2689, -8],
      [2727, 194],
      [455, 357],
      [1416, -520],
      [636, 62],
      [1650, -46],
    ],
    [
      [73074, 77131],
      [-351, -1660],
      [-844, -1474],
      [-585, -1381],
      [-766, -846],
      [-468, -201],
      [-285, -427],
      [-1014, -985],
      [-4610, -2863],
    ],
    [[64151, 67294], [-1104, 1141], [-689, 853], [-117, 946]],
    [[66307, 80668], [1311, -706]],
    [[67618, 79962], [1014, -473]],
    [[68632, 79489], [1571, -714], [2000, 1994]],
    [[72203, 80769], [559, 132], [1026, -567], [857, -853], [1182, -1365]],
    [[75827, 78116], [780, -2669]],
    [[76607, 75447], [-3533, 1684]],
    [[76607, 75447], [610, -1637]],
    [[77217, 73810], [416, -597], [714, -1644]],
    [
      [78347, 71569],
      [-1052, 147],
      [-753, -644],
      [-1026, -651],
      [-429, -575],
      [-234, -721],
    ],
    [
      [74853, 69125],
      [-1065, -783],
      [-1390, -497],
      [-792, -1823],
      [-1182, -54],
      [-3948, 77],
      [-1468, 109],
      [-857, 1140],
    ],
    [[67476, 90046], [1792, 132], [2234, -822], [896, -566]],
    [
      [72398, 88790],
      [-649, -380],
      [-935, -93],
      [-1273, 1055],
      [-741, 527],
      [-285, -62],
      [169, -574],
      [298, -210],
      [520, -1853],
      [1571, -2545],
      [-1350, -1163],
    ],
    [[72398, 88790], [3144, -287], [1156, -435], [1402, -62]],
    [
      [78100, 88006],
      [-1208, -946],
      [-1753, -605],
      [-766, -101],
      [-884, -559],
      [-2234, -2544],
      [-519, -527],
      [-3118, -2762],
    ],
    [
      [68632, 79489],
      [3403, 2979],
      [2234, 837],
      [714, 55],
      [312, 574],
      [506, 248],
    ],
    [
      [75801, 84182],
      [1039, -706],
      [260, -349],
      [-935, -690],
      [468, -745],
      [-429, -636],
      [-1208, -140],
      [-1390, 202],
      [-740, 287],
      [-663, -636],
    ],
    [
      [71463, 93111],
      [169, 690],
      [286, 225],
      [1026, 333],
      [91, 582],
      [1182, 264],
      [91, 574],
      [922, 528],
      [857, -233],
      [546, 310],
      [1337, -85],
      [1078, -264],
      [273, -388],
      [-415, -450],
    ],
    [[78906, 95197], [-754, -85], [-402, -520], [220, -481]],
    [
      [77970, 94111],
      [-493, -108],
      [-1325, -629],
      [390, -263],
      [-234, -179],
      [1532, -1357],
      [-363, -799],
      [312, -117],
      [-156, -752],
      [2273, -885],
    ],
    [[79906, 89022], [-793, -318]],
    [[79113, 88704], [-493, -201], [-520, -497]],
    [[78100, 88006], [260, 8], [1870, -853], [598, -210]],
    [[80828, 86951], [-2962, -2234], [-896, -465], [-610, 201], [-559, -271]],
    [[80828, 86951], [1078, -682], [2208, -303]],
    [
      [84114, 85966],
      [-753, -628],
      [-26, -458],
      [-832, -1210],
      [-1532, -1117],
      [-806, -411],
      [-2467, -1598],
      [857, -807],
    ],
    [[78555, 79737], [-507, -240], [-2221, -1381]],
    [[78347, 71569], [935, 0]],
    [
      [79282, 71569],
      [494, -1133],
      [-65, -760],
      [532, -551],
      [1078, -683],
      [1390, -1551],
    ],
    [
      [82711, 66891],
      [-4000, -357],
      [-3118, 0],
      [-415, 148],
      [-260, 2443],
      [-65, 0],
    ],
    [[78555, 79737], [2792, -39]],
    [[81347, 79698], [936, -613], [1662, -930], [-597, -683]],
    [
      [83348, 77472],
      [-1546, -1365],
      [-286, 248],
      [-701, -272],
      [-2559, -768],
      [-260, 272],
      [-779, -1777],
    ],
    [[77970, 94111], [1494, -1016], [1312, -512], [1104, -186]],
    [[81880, 92397], [286, -504], [-247, -1792], [-2013, -1079]],
    [[83348, 77472], [2104, -1544]],
    [[85452, 75928], [221, -768]],
    [
      [85673, 75160],
      [-1247, -341],
      [-1143, -582],
      [-1156, -745],
      [-338, -574],
      [546, -504],
    ],
    [[82335, 72414], [-793, -139], [-1260, -489], [-1000, -217]],
    [[84114, 85966], [1753, -543]],
    [[85867, 85423], [3326, -1373], [-520, -427]],
    [
      [88673, 83623],
      [-273, -822],
      [-844, 132],
      [-156, -458],
      [-649, -101],
      [-1143, 179],
      [-234, 310],
      [-2351, -1187],
      [-442, -442],
      [-1234, -1536],
    ],
    [
      [78906, 95197],
      [415, -465],
      [1000, -179],
      [1494, -93],
      [2182, -644],
      [65, -294],
      [-533, -295],
      [78, -636],
    ],
    [[83607, 92591], [-1727, -194]],
    [
      [79113, 88704],
      [1468, -589],
      [2598, 1831],
      [441, 434],
      [1481, -171],
      [792, 636],
      [2195, 1055],
      [507, -287],
      [1143, 761],
    ],
    [[89738, 92374], [312, -443], [805, 78]],
    [[90855, 92009], [-65, -85], [1663, -970], [168, -745]],
    [
      [92621, 90209],
      [-675, -411],
      [-2416, -923],
      [-623, -605],
      [-260, -729],
      [-572, -264],
      [-493, 54],
      [-883, -899],
      [-832, -1009],
    ],
    [[83607, 92591], [468, -202], [1403, 1583], [169, 325]],
    [[85647, 94297], [2416, -884], [441, -388], [1234, -651]],
    [
      [82335, 72414],
      [1831, -1334],
      [987, -1296],
      [948, -543],
      [299, 86],
      [792, -760],
      [585, 108],
      [1104, -357],
      [792, -527],
    ],
    [[89673, 67791], [-5663, -791], [-1299, -109]],
    [
      [88673, 83623],
      [1909, -356],
      [1325, -582],
      [-351, -334],
      [832, -481],
      [519, -597],
    ],
    [
      [92907, 81273],
      [-1299, -287],
      [-1182, -163],
      [39, -171],
      [-974, -139],
      [-1896, -31],
      [-494, -714],
      [3546, -1582],
      [-467, -396],
      [52, -318],
    ],
    [[90232, 77472], [-429, 124], [-1922, -908], [-1299, -147], [-1130, -613]],
    [[85673, 75160], [1727, -2187], [1715, -3134], [3247, -1870]],
    [[92362, 67969], [-2689, -178]],
    [[86790, 97881], [-767, -566]],
    [
      [86023, 97315],
      [-2052, 908],
      [-208, 356],
      [416, 443],
      [286, -202],
      [467, 233],
      [39, 411],
      [1104, -202],
      [442, -768],
      [753, 372],
      [689, 78],
      [480, -512],
      [-1532, -295],
      [-117, -256],
    ],
    [
      [90232, 77472],
      [1221, -450],
      [-91, -217],
      [1039, -900],
      [-1533, -830],
      [-247, -295],
      [624, -613],
      [221, -659],
      [246, 0],
      [520, -1660],
      [26, -2141],
      [1403, -1249],
      [584, -365],
      [-1883, -124],
    ],
    [[85647, 94297], [779, 1288], [1026, 1016]],
    [[87452, 96601], [390, -263], [597, 488], [1611, -574], [2169, -1047]],
    [
      [92219, 95205],
      [-169, -124],
      [1377, -388],
      [299, -365],
      [-1741, -1109],
      [701, -295],
    ],
    [[92686, 92924], [-1130, -706], [-701, -209]],
    [[92621, 90209], [-12, -310], [1727, -1373]],
    [
      [94336, 88526],
      [403, -279],
      [1182, -326],
      [441, -233],
      [-2299, -2009],
      [1845, -551],
      [-845, -1303],
      [-545, -543],
      [610, -349],
      [-1571, -1885],
      [-650, 225],
    ],
    [
      [86790, 97881],
      [2493, -551],
      [455, 1280],
      [1883, 737],
      [-91, 241],
      [377, 411],
      [533, -326],
      [402, -667],
      [1312, -489],
      [-428, -240],
      [168, -334],
      [-1298, -488],
      [-260, -388],
      [636, -210],
      [-584, -605],
      [1260, -395],
      [-1429, -652],
    ],
    [[87452, 96601], [-1429, 714]],
    [
      [92686, 92924],
      [1221, -605],
      [1741, 885],
      [415, -124],
      [1014, -675],
      [350, 163],
      [1117, -218],
      [390, -411],
      [1065, -636],
      [-2234, -962],
      [39, -85],
      [-1429, -652],
      [-597, -473],
      [-1442, -605],
    ],
    [[28289, 54790], [0, 0]],
    [[27497, 55255], [0, 0]],
  ],
}



// WEBPACK FOOTER //
// ./src/data/burgenland.topojson.js